<template>
  <div class="content-container tab-container flex-row">
    <TheLoader :active="loading"/>

    <section class="content large-padding overflow-section">
      <div v-if="bidHistory.length > 0" class="animate-in">
        <table class="medium padding margin-top margin-bottom">
          <thead>
          <tr>
            <th>Kundenr</th>
            <th>Kundenavn</th>
            <th>Tid</th>
            <th>Beløp</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(history, key) in bidHistory" v-bind:key="key" class="animate-in">
            <td>
              <span>{{ history.customer_number }}</span>
            </td>
            <td>
              <span>{{ history.customer_name }}</span>
            </td>
            <td>
              <span>{{ history.date }}</span>
            </td>
            <td>
              <span>{{ history.value }}</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else>Ingen bud funnet</div>
    </section>
  </div>
</template>

<script>

import ObjektService from '../../services/ObjektService'

export default {
  name: 'KundeKontraktObjektTabBudhistorikk',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      loading: true,
      bidHistory: []
    }
  },
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  computed: {
    item: function () {
      return this.$store.getters['objektkonsult/item']
    },
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    }
  },
  watch: {
  },
  created () {
    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid
  },
  mounted () {
    this.getBidHistory()
  },
  methods: {
    getBidHistory () {
      ObjektService.getBidHistoryComplete(this.objekt.Objektid)
        .then((response) => {
          this.bidHistory = response.data
          this.loading = false
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Vi kan ikke få budlisten')
          this.loading = false
        })
    },
    print: function () {
      window.print()
    }
  }
}
</script>
<style scoped>
.overflow-section {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabBudhistorikk.vue